import { OrdineVendita } from '../_models/OrdineVendita';

// Helper centralizzati per stato ordine / stato consegna degli Ordini Clienti.
// Sostituiscono le copie duplicate in vendita-home, ordine-vendita-item e ordini-vendita-groupbymany.

// Codici stato che identificano una riga "da non gestire più" (ordine non accettato o concluso).
const STATO_ORDINE_ANNULLATO = 73;
const STATO_CONSEGNA_CONSEGNATO = 2;
const STATO_CONSEGNA_ANNULLATO = 3;

export function getStatoOrdineLabel(stato: number): string {
  switch (stato) {
    case 70: return 'Indicativo';
    case 71: return 'Da confermare';
    case 72: return 'Definitivo';
    case 73: return 'Annullato';
    case 5:  return 'Sospeso';
    default: return 'N/D';
  }
}

export function getStatoOrdineClass(stato: number): string {
  switch (stato) {
    case 70: return 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-400';
    case 71: return 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400';
    case 72: return 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400';
    case 73: return 'bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-400';
    case 5:  return 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400';
    default: return 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400';
  }
}

export function getStatoOrdineBorderClass(ordine: OrdineVendita): string {
  if (ordine.flgTerminato) return 'border-l-gray-400';
  switch (ordine.statoOrdine) {
    case 70: return 'border-l-yellow-400';
    case 71: return 'border-l-amber-400';
    case 72: return 'border-l-blue-500';
    case 73: return 'border-l-red-400';
    case 5:  return 'border-l-gray-300';
    default: return 'border-l-gray-400';
  }
}

export function getStatoConsegnaLabel(stato: number): string {
  switch (stato) {
    case 0: return 'In corso';
    case 1: return 'In preparazione';
    case 2: return 'Consegnato';
    case 3: return 'Annullato';
    default: return 'N/D';
  }
}

export function getStatoConsegnaClass(stato: number): string {
  switch (stato) {
    case 0: return 'bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-400';
    case 1: return 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400';
    case 2: return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400';
    default: return 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400';
  }
}

// Riga "da non gestire più": ordine Annullato, oppure consegna Consegnata o Annullata.
export function isOrdineDaNonGestire(ordine: OrdineVendita): boolean {
  return ordine.statoOrdine === STATO_ORDINE_ANNULLATO
    || ordine.statoConsegna === STATO_CONSEGNA_CONSEGNATO
    || ordine.statoConsegna === STATO_CONSEGNA_ANNULLATO;
}

// Sfondo rosso chiaro per evidenziare le righe da non gestire, altrimenti nessuna classe.
// Variante dark esplicita: tinta rossa attenuata sul fondo scuro, distinta dall'hover.
export function getStatoRowBackgroundClass(ordine: OrdineVendita): string {
  return isOrdineDaNonGestire(ordine) ? 'bg-red-100 dark:bg-red-900/30' : '';
}
